if (document.getElementById('slider')) {
  const child1 = document.querySelector('.slide')
  const parent = document.getElementById('slider')

  const childHeight = parseInt(window.getComputedStyle(child1).height) + 'px'
  parent.style.height = childHeight

  document.getElementById('navigation').style.height = childHeight

  const slider = document.querySelector('.slider')
  const nextBtn = document.querySelector('.next-btn')
  const prevBtn = document.querySelector('.prev-btn')
  const slides = document.querySelectorAll('.slide')
  const numberOfSlides = slides.length
  let slideNumber = 0

  // image slider next button
  nextBtn.addEventListener('click', () => {
    slides.forEach((slide) => {
      slide.classList.remove('active')
    })

    slideNumber++

    if (slideNumber > (numberOfSlides - 1)) {
      slideNumber = 0
    }

    slides[slideNumber].classList.add('active')
  })

  // image slider previous button
  prevBtn.addEventListener('click', () => {
    slides.forEach((slide) => {
      slide.classList.remove('active')
    })

    slideNumber--

    if (slideNumber < 0) {
      slideNumber = numberOfSlides - 1
    }

    slides[slideNumber].classList.add('active')
  })

  // image slider autoplay
  let playSlider

  const repeater = () => {
    playSlider = setInterval(function () {
      slides.forEach((slide) => {
        slide.classList.remove('active')
      })

      slideNumber++

      if (slideNumber > (numberOfSlides - 1)) {
        slideNumber = 0
      }

      slides[slideNumber].classList.add('active')
    }, 9000)
  }
  repeater()

  // stop the image slider autoplay on mouseover
  slider.addEventListener('mouseover', () => {
    clearInterval(playSlider)
  })

  // start the image slider autoplay again on mouseout
  slider.addEventListener('mouseout', () => {
    repeater()
  })
}
